export default __webpack_public_path__ + "static/pie-in-a-doughnut-414bfd14ea7197a5c3c6b6bab8173867.png";